
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Formula } from '@/types/formula';

interface FormulaCreateData {
  name: string;
  description: string;
  materials: any[];
}

export const useCreateFormula = (portfolioId: string) => {
  const queryClient = useQueryClient();
  
  const createFormulaMutation = async (data: FormulaCreateData): Promise<Formula> => {
    // For now, mock the creation process
    // In a real app, this would insert into Supabase
    
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Create mock response
    const newFormula: Formula = {
      id: Date.now().toString(),
      portfolio_id: portfolioId,
      name: data.name,
      description: data.description,
      status: 'draft',
      component_count: data.materials.length,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
    
    return newFormula;
  };
  
  const createFormula = useMutation({
    mutationFn: createFormulaMutation,
    onSuccess: () => {
      // Invalidate and refetch formulas list
      queryClient.invalidateQueries({ queryKey: ['formulas', portfolioId] });
    },
  });
  
  return {
    createFormula,
    isLoading: createFormula.isPending,
  };
};
